import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa6";
import { Rounded } from "../../assets/images";
import { ZoomChatImage } from "..";

type FilePreviewProps = {
  imageLoading: boolean;
  progress: number;
  imageUrls: string[];
  fileUrls?: string[];
  deleteImage: (imageUrlToDelete: string) => Promise<void>;
  margin?: string;
};

const FilePreview: React.FC<FilePreviewProps> = ({
  imageLoading,
  imageUrls,
  progress,
  fileUrls,
  deleteImage,
  margin,
}) => {
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = imageUrls?.length || 0;

  const handleClick = (index: number) => {
    setShowAllImages(index);
    setCurrentIndex(index);
  };
  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < totalImages - 1 ? prevIndex + 1 : prevIndex
    );
  };
  if (showAllImages !== null) {
    document.body.classList.add("picModal");
    // console.log("its hidden");
  } else {
    document.body.classList.remove("picModal");
  }
  return (
    <div>
      {imageUrls && showAllImages !== null && totalImages > 0 && (
        <ZoomChatImage
          setShowAllImages={setShowAllImages}
          handleNext={handleNext}
          handlePrev={handlePrev}
          totalImages={totalImages}
          image={imageUrls}
          currentIndex={currentIndex}
          fileUrls={fileUrls}
          key={imageUrls.length + 3}
          margin={margin}
        />
      )}
      <div className="flex lg:w-[800px] h-fit gap-1 overflow-scroll py-1 j f relative">
        {imageLoading && (
          <div className="flex items-center w-[119px] h-[119px] rounded bg-[#ECE6E6] justify-center">
            <img src={Rounded} alt="" className="h-10 w-10 animate-spin" />
          </div>
        )}

        {progress > 0 && progress !== 100 && (
          <div className="flex items-center w-[119px] h-20 justify-center relative">
            <FaRegFilePdf size={35} fill="red" />
            <div className="flex absolute items-center justify-center top-[30px] left-[38px]">
              <img src={Rounded} alt="" className="h-5 w-5 animate-spin" />
              <p className=" font-Poppins text-[20px] text-slate-800">
                {progress}%
              </p>
            </div>
          </div>
        )}
        <div className="flex w-full">
          {(imageUrls || fileUrls) &&
            imageUrls.length > 0 &&
            imageUrls.map((image, index) => (
              <div className="flex">
                {image &&
                (image.includes("ecobookImages") ||
                  image.includes("ecomotoImages"))
                  ? imageUrls[index] && (
                      <div
                        className="flex p-1 w-[119px] cursor-pointer h-[119px] rounded relative"
                        key={index}
                        onClick={() => handleClick(index)}
                      >
                        <img
                          key={index}
                          src={image}
                          alt="Preview"
                          className="object-cover object-center rounded"
                        />
                        <button
                          onClick={() => {
                            deleteImage(image);
                          }}
                          className="py-2 px-2
            rounded-full text-[#33363F]
            bg-[#ECE6E6] active:bg-bgGrey
            hover:text-gray-600 absolute top-1 right-1"
                        >
                          <AiOutlineClose size={20} />
                        </button>
                      </div>
                    )
                  : fileUrls &&
                    fileUrls.length > 0 && (
                      <div
                        className="flex items-center w-[120px] h-[119px] justify-center relative"
                        key={index}
                        onClick={() => handleClick(index)}
                      >
                        <FaRegFilePdf size={55} />
                        <button
                          onClick={() => {
                            deleteImage(image);
                          }}
                          className="py-2 px-2
          rounded-full text-[#33363F]
          bg-[#ECE6E6] active:bg-bgGrey
          hover:text-gray-600 absolute top-1 right-0"
                        >
                          <AiOutlineClose size={20} />
                        </button>
                      </div>
                    )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default FilePreview;
